const FREE_SHIPPING_COUPON_DESCRIPTION_PATTERN = /frete\s*gr[aá]tis/i
const FREE_SHIPPING_COUPON_CODE_PATTERN = /FRETE/i

export type CouponLike = { description?: string; code?: string } | null

export function isFreeShippingCoupon(coupon: CouponLike): boolean {
  return (
    !!coupon &&
    ((!!coupon.description &&
      FREE_SHIPPING_COUPON_DESCRIPTION_PATTERN.test(coupon.description)) ||
      (!!coupon.code && FREE_SHIPPING_COUPON_CODE_PATTERN.test(coupon.code)))
  )
}

export function canShowEditByCouponRule(
  coupon: CouponLike,
  sellerCouponEditOn: boolean
): boolean {
  return !coupon || isFreeShippingCoupon(coupon) || sellerCouponEditOn
}
